interface Props {
  size?: 'sm' | 'md' | 'lg';
  /**
   * `current` herda a cor do texto — para spinner dentro de botão preenchido,
   * onde o `brand` some contra o próprio fundo do botão.
   */
  tone?: 'brand' | 'current';
}

const sizes = { sm: 'h-4 w-4', md: 'h-8 w-8', lg: 'h-12 w-12' };
const tones = { brand: 'border-brand-600', current: 'border-current' };

export default function LoadingSpinner({ size = 'md', tone = 'brand' }: Readonly<Props>) {
  return (
    <div className={`animate-spin rounded-full border-b-2 ${tones[tone]} ${sizes[size]}`} />
  );
}
